import React from "react"

const WindowContext = React.createContext({ width: 375, height: 667 })

export default WindowContext
